var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindowsColorIcon = function SvgWindowsColorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#windows-color-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00ADEF",
    d: "m0 3.382 9.733-1.325.004 9.388L.01 11.5zm9.728 9.145.008 9.396-9.728-1.337v-8.122zm1.18-10.644L23.813 0v11.326l-12.905.102zm12.908 10.732-.003 11.275-12.905-1.822-.018-9.474z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "windows-color-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgWindowsColorIcon;